import { Injectable } from '@angular/core';
import { generateClient } from '@aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateProductLabelInput,
    DeleteProductLabelInput,
    ProductLabel,
    UpdateProductLabelInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class ProductLabelService {
    private amplifyClient = generateClient();

    async getProductLabel(id: string): Promise<ProductLabel> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getProductLabel,
                    variables: {
                        id
                    }
                })
            ).data.getProductLabel;
            if (data) return data as ProductLabel;
        } catch (error) {
            console.error('Error finding ProductLabel:', error);
            return null;
        }
    }

    async listProductLabels(): Promise<ProductLabel[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listProductLabels
                })
            ).data.listProductLabels.items;
            if (data) return data as ProductLabel[];
        } catch (error) {
            console.error('Error finding ProductLabel:', error);
            return null;
        }
    }

    async ProductLabelsByName(name: string): Promise<ProductLabel[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.ProductLabelsByName,
                    variables: {
                        name
                    }
                })
            ).data.ProductLabelsByName.items;
            if (data) return data as ProductLabel[];
        } catch (error) {
            console.error('Error finding ProductLabelItem:', error);
            return null;
        }
    }

    async productLabelsByTranslation(
        translation: string
    ): Promise<ProductLabel[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.ProductLabelsByTranslation,
                    variables: {
                        translation
                    }
                })
            ).data.ProductLabelsByTranslation.items;
            if (data) return data as ProductLabel[];
        } catch (error) {
            console.error('Error finding ProductLabel:', error);
            return null;
        }
    }
    async productLabelsByStatusm(status: string): Promise<ProductLabel[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.ProductLabelsByStatus,
                    variables: {
                        status
                    }
                })
            ).data.ProductLabelsByStatus.items;
            if (data) return data as ProductLabel[];
        } catch (error) {
            console.error('Error finding ProductLabel:', error);
            return null;
        }
    }

    async createProductLabel(
        input: CreateProductLabelInput
    ): Promise<ProductLabel> {
        try {
            const productOption = (
                await this.amplifyClient.graphql({
                    query: mutations.createProductLabel,
                    variables: {
                        input
                    }
                })
            ).data.createProductLabel;
            if (productOption) return productOption as ProductLabel;
        } catch (error) {
            console.error('Error creating ProductLabelItem:', error);
            return null;
        }
    }

    async updateProductLabel(
        input: UpdateProductLabelInput
    ): Promise<ProductLabel> {
        try {
            const productOption = (
                await this.amplifyClient.graphql({
                    query: mutations.updateProductLabel,
                    variables: {
                        input
                    }
                })
            ).data.updateProductLabel;
            if (productOption) return productOption as ProductLabel;
        } catch (error) {
            console.error('Error updating ProductLabel:', error);
            return null;
        }
    }

    async deleteProductLabel(
        input: DeleteProductLabelInput
    ): Promise<ProductLabel> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.deleteProductLabel,
                    variables: {
                        input
                    }
                })
            ).data.deleteProductLabel;
            if (date) return date as ProductLabel;
        } catch (error) {
            console.error('Error creating ProductLabel:', error);
            return null;
        }
    }
}
